module.exports = __webpack_public_path__ + "static/1203779462-exit.7e360d1c.jpg";